import { TokenPairDto } from '@/app/store/api/restApi';

const ACCESS_KEY = 'authToken_client';
const REFRESH_KEY = 'refreshToken_client';
const EXPIRES_AT_KEY = 'authTokenExpiresAt_client';

const STALE_BUFFER_SECONDS = 60;

export const getAccessToken = (): string | null => localStorage.getItem(ACCESS_KEY);

export const getRefreshToken = (): string | null => localStorage.getItem(REFRESH_KEY);

export const setTokens = (pair: TokenPairDto): void => {
  localStorage.setItem(ACCESS_KEY, pair.accessToken);
  localStorage.setItem(REFRESH_KEY, pair.refreshToken);
  localStorage.setItem(EXPIRES_AT_KEY, String(Date.now() + pair.expiresInSeconds * 1000));
};

export const clearTokens = (): void => {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(EXPIRES_AT_KEY);
};

// True when the access token is missing, already expired, or within the refresh
// buffer of expiring. Used after a page resume (e.g. phone unlocked) to decide
// whether initialization must re-run before any authenticated request is issued.
export const isTokenStale = (bufferSeconds = STALE_BUFFER_SECONDS): boolean => {
  const raw = localStorage.getItem(EXPIRES_AT_KEY);
  if (!raw) return true;
  const expiresAt = Number(raw);
  if (Number.isNaN(expiresAt)) return true;
  return Date.now() >= expiresAt - bufferSeconds * 1000;
};
